export const STATUS = {
  0: "pending",
  1: "approved",
  2: "rejected",
};
